import simpleModal from "../libs/simpleModal";
import mobileDrawer from "../libs/mobileDrawer";

export default context => {
    $('#OrgCalendarsButton', context).click(function() {
        const modal = new simpleModal({
            id: 'OrgCalendars',
            header: 'Subscribe to Calendars',
        })
        modal.loadContent({
            url: window.community.url + '/org-calendars',
        })
    })

    $('#mobileOrgCalendarsButton', context).click(async function() {
        const data = await $.get(window.community.url + '/org-calendars')
        const drawer = mobileDrawer('OrgCalendars', data.body)
        return false
    })
}
